// extracted by mini-css-extract-plugin
export default {"zone":"style_zone__taWqP","dropping":"style_dropping__BC5hc"};